export default __webpack_public_path__ + "static/053-b3e5720a811af438e29c5881715a3fbb.jpg";